
import { Outlet, useLocation } from 'react-router-dom';

import Topbar from '../components/topbar/Topbar';

const Layout = () => {
    const location = useLocation();
    const isJobDetailsOverview = /^\/jobs\/[^/]+(?:\/details)?\/?$/.test(location.pathname);
    const isJobsQueue = location.pathname === '/' ||
        location.pathname === '/home' ||
        location.pathname === '/home/' ||
        location.pathname === '/jobs' ||
        location.pathname === '/jobs/';
    const isCreateJobWizard = /^\/create-job(?:\/[^/]+)?\/?$/.test(location.pathname);
    const isScheduler = location.pathname === '/scheduler' || location.pathname.startsWith('/scheduler/');
    const isFlushWithTopbar = isJobDetailsOverview || isJobsQueue || isCreateJobWizard || isScheduler;

    return (
        <>
            <Topbar />
            {!isFlushWithTopbar && <div data-testid="layout-top-spacer" style={{ marginTop: '20px' }}></div>}
            <div className="flex">
                <div className="w-full">
                    <div data-testid="layout-content" className={isFlushWithTopbar ? '' : 'mt-3'}>
                        <Outlet />
                    </div>
                </div>
            </div>
        </>
    )
}

export default Layout;
